var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYou(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 15,
    viewBox: "0 0 21 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2884 14.9033L7.22617 14.8273C5.91092 14.8009 4.5924 14.8537 3.30294 14.5796C1.34138 14.1701 1.20241 12.1622 1.057 10.478C0.856641 8.11012 0.934207 5.6993 1.31232 3.35123C1.52577 2.03371 2.3658 1.24754 3.66488 1.16199C8.05023 0.851513 12.4647 0.888307 16.8404 1.03315C17.3025 1.04643 17.7678 1.11901 18.2235 1.20162C20.4728 1.60454 20.5276 3.87994 20.6734 5.79539C20.8189 7.73061 20.7575 9.67577 20.4795 11.5978C20.2566 13.1892 19.8299 14.5238 18.0296 14.6526C15.7738 14.8211 13.5698 14.9567 11.3077 14.9135C11.3078 14.9033 11.2948 14.9033 11.2884 14.9033ZM8.90019 10.8743C10.6001 9.87688 12.2676 8.89609 13.9577 7.90536C12.2547 6.90795 10.5904 5.92716 8.90019 4.93644V10.8743Z",
    fill: "#191919"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYou);
export default __webpack_public_path__ + "static/media/you.fed803a064ca922382eb744b6384be56.svg";
export { ForwardRef as ReactComponent };